module.exports = __webpack_public_path__ + "static/media/off.ed343b96.png";